module.exports = __webpack_public_path__ + "media/images/realizacje/real2-46e52daa2f69e918c8a48ad0807c45d3.png";